import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";
import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const ProjectCategory = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getCategory = () => {
    axios
      .get(`${baseUrl}/blog/project-category-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setData(res?.data?.data || []);
      })
      .catch(() => {
        toast.error("Failed to load categories");
      });
  };

  const deleteCategory = (id) => {
    axios
      .delete(`${baseUrl}/blog/project-category-api/`, {
        data: { projectcategory_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        toast.success(res?.data?.message || "Category deleted");
        getCategory();
      })
      .catch(() => {
        toast.error("Error deleting category");
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  return (
    <div className="w-full min-h-screen px-2 py-3">
      {/* Header */}
      <p className="my-4 sm:my-0 text-3xl sm:text-4xl lg:text-5xl text-center text-blue-900 underline">
        Project Category
      </p>

      {/* Add Button */}
      <div className="flex justify-end mb-2">
        <NavLink to="/Project_category/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {data.map((item) => (
          <div
            key={item.id}
            className="flex flex-col h-full p-4 bg-white border border-gray-300 rounded-lg shadow-md"
          >
            {/* Name */}
            <p className="mb-3 text-lg font-semibold text-black break-words text-center sm:text-left">
              {item.name}
            </p>

            {/* Image */}
            {item?.images && (
              <img
                src={item.images}
                alt={item.name}
                className="w-full h-40 object-cover rounded-md mb-4"
              />
            )}

            {/* Buttons */}
            <div className="flex flex-wrap justify-center gap-4 mt-auto">
              <Button
                className="w-full sm:w-auto"
                onClick={() =>
                  navigate("/project_category/update", {
                    state: item.id,
                  })
                }
                variant="outlined"
              >
                Update
              </Button>

              <Button
                className="w-full sm:w-auto"
                onClick={() => deleteCategory(item.id)}
                variant="outlined"
                color="error"
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectCategory;
